export default "__VITE_ASSET__BnKvBcfS__"